export default {
  searchIssueCredit: {
    title: '信用证开证查询',
    search: {
      companyCode: '公司',
      companyCodePlaceholder: '请选择公司',
      departmentCodes: '部门',
      departmentCodesPlaceholder: '请选择部门',
      applyNo: '申请单号',
      applyNoPlaceholder: '请输入申请单号',
      applyDateStart: '申请日期从',
      applyDateStartPlaceholder: '请选择开始日期',
      applyDateEnd: '申请日期到',
      applyDateEndPlaceholder: '请选择结束日期',
      partnerCodes: '受益人',
      partnerCodesPlaceholder: '请选择受益人',
      applyClAmount: '开证申请金额',
      applyUserName: '申请人',
      applyUserNamePlaceholder: '请输入申请人',
      clCode: '信用证号',
      clCodePlaceholder: '请输入信用证号',
      issueDateStart: '开证日期从',
      issueDateStartPlaceholder: '请选择开始日期',
      issueDateEnd: '开证日期到',
      issueDateEndPlaceholder: '请选择结束日期',
      clType: '信用证类别',
      clTypePlaceholder: '请选择信用证类别',
      bankId: '开证银行',
      bankIdPlaceholder: '请选择开证银行',
      currencyCode: '币别',
      currencyCodePlaceholder: '请选择币别',
      acceptDateStart: '承兑日期从',
      acceptDateStartPlaceholder: '请选择开始日期',
      acceptDateEnd: '承兑日期到',
      acceptDateEndPlaceholder: '请选择结束日期',
      statusFlag: '信用证状态',
      statusFlagPlaceholder: '请选择信用证状态',
      accStatusFlag: '承兑状态',
      accStatusFlagPlaceholder: '请选择承兑状态',
      accountStatus: '入账状态',
      accountStatusPlaceholder: '请选择入账状态',
      paymentDateStart: '应付汇日期从',
      paymentDateStartPlaceholder: '请选择开始日期',
      paymentDateEnd: '应付汇日期到',
      paymentDateEndPlaceholder: '请选择结束日期',
      issueType: '开证类型',
      issueTypePlaceholder: '请选择开证类型',
      isAccpetComplete: '是完全承兑',
      isPayComplete: '是完全付款',
      clAmount: '开证金额',
      acceptAmount: '承兑金额',
      delayPaymentType1: '部门不押汇公司押汇',
      delayPaymentType2: '部门押汇公司不押',
      delayPaymentType3: '部门押汇且公司押汇',
      accIsLockExchangeRate: '是押汇锁汇',
      isLockExchangeRate: '是承兑锁汇',
    },
    table: {
      companyName: '公司',
      departmentName: '部门',
      applyNo: '申请单号',
      applyUserName: '申请人',
      applyDate: '申请日期',
      clType: '信用证类别',
      clAmount: '开证金额',
      currencyName: '币别',
      clCode: '信用证号',
      issueDate: '开证日期',
      bankBranch: '开证银行',
      issueType: '开证类型',
      partnerName: '受益人',
      acceptanceAmount: '已承兑金额',
      paidAmount: '已付款金额',
      isAccpetComplete: '是否完全承兑',
      isPayComplete: '是否完全支付',
      statusFlag: '信用证状态',
      applyClAmount: '开证申请金额',
      accountStatus: '入账状态',
    },
    msg: {
      validDate: '有效期开始时间不能大于有效期截止时间',
      overlayDate: '有效期重叠，不可新增',
      onlyOne: '该请求只能选择一个记录',
      applicationButTip: '最多选择一条记录',
      addApplyTip: '只有已保存和已驳回状态才能进行该操作！',
      issuingTip: '只有申请单为已通过才能进行开证！',
      acceptanceTip: '只有申请单为已开证,已承兑状态时才能进行该操作！',
    },
    tips: {
      noSelectData: '请至少选择一条数据进行操作',
      onlyOneSelectData: '请选择一条数据进行操作',
      noExport: '当前没有数据可以导出！',
      noDelect: '只有已登记数据可以删除，请重新选择！',
      noCanDelSelectData: '所选数据中没有已保存和已驳回状态，请重新选择！',
      hasCannotDelTip: '所选数据中有不可删除的数据，点击确认只会删除已保存和已驳回状态的数据！',
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
    },
  },
};
